(function () {
  function initBmgMotion() {
    var root = document.querySelector('.bmg-motion-root');
    if (!root || root.dataset.motionReady === 'true') return;
    root.dataset.motionReady = 'true';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var reveals = root.querySelectorAll('[data-bmg-reveal]');
    reveals.forEach(function (el) { var delay = parseInt(el.getAttribute('data-bmg-delay') || '0', 10); el.style.setProperty('--bmg-reveal-delay', delay + 'ms'); });
    if (reduce || !('IntersectionObserver' in window)) { reveals.forEach(function (el) { el.classList.add('is-visible'); }); return; }
    var observer = new IntersectionObserver(function (entries, obs) { entries.forEach(function (entry) { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); obs.unobserve(entry.target); } }); }, { threshold: 0.12, rootMargin: '0px 0px -7% 0px' });
    reveals.forEach(function (el) { observer.observe(el); });
    var parallax = root.querySelectorAll('[data-bmg-parallax]');
    if (!parallax.length || window.innerWidth <= 900) return;
    var ticking = false;
    function updateParallax() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      parallax.forEach(function (wrap) {
        var rect = wrap.getBoundingClientRect();
        if (rect.bottom < -100 || rect.top > vh + 100) return;
        var speed = parseFloat(wrap.getAttribute('data-bmg-parallax-speed') || '0.05');
        var center = rect.top + rect.height / 2;
        var offset = (center - vh / 2) * speed * -1;
        var cap = Math.min(46, Math.max(18, rect.height * 0.055));
        offset = Math.max(-cap, Math.min(cap, offset));
        wrap.style.setProperty('--bmg-parallax-y', offset.toFixed(2) + 'px');
      });
      ticking = false;
    }
    function requestTick() { if (!ticking) { window.requestAnimationFrame(updateParallax); ticking = true; } }
    updateParallax();
    window.addEventListener('scroll', requestTick, { passive: true });
    window.addEventListener('resize', requestTick, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBmgMotion); else initBmgMotion();
  document.addEventListener('shopify:section:load', initBmgMotion);
})();